export default __webpack_public_path__ + "static/media/esgot-screenshot-01.fc52a3ad.png";